import React from "react";
import { Phone, ArrowRight, Star, Mouse } from "lucide-react";
import { PHONE, PHONE_TEL, heroTags, heroImage } from "../mock";

const Hero = () => {
  return (
    <section id="top" className="relative overflow-hidden bg-[#f4f2fb]">
      {/* background network image */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src={heroImage}
          alt="Abstract network connection"
          className="w-full h-full object-cover opacity-[0.18]"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#f4f2fb] via-[#f4f2fb]/70 to-[#e9e3fb]/60" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-36 pb-24 lg:pt-44 lg:pb-32">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2.5 rounded-full bg-white/70 backdrop-blur border border-[#1e183a]/10 px-4 py-2 shadow-sm reveal">
            <span className="w-2.5 h-2.5 rounded-full bg-[#7c3aed] animate-soft-pulse" />
            <span className="text-xs font-semibold tracking-[0.18em] text-[#1e183a]">
              UK ADVISORS AVAILABLE NOW
            </span>
          </div>

          <h1 className="reveal mt-7 font-display font-semibold leading-[0.98] text-[#1e183a] text-[3.2rem] sm:text-6xl lg:text-[5.2rem]">
            Independent Mobile &amp; SIM Support &mdash;{" "}
            <span className="text-[#7c3aed]">For Free</span>
          </h1>

          <p className="reveal mt-6 text-lg text-[#1e183a]/70 max-w-xl leading-relaxed">
            Free, independent third-party mobile &amp; SIM support. Expert advice
            for all your mobile and SIM card queries &mdash; 7 days a week, at no
            cost.
          </p>

          <div className="reveal mt-9 flex flex-col sm:flex-row gap-4">
            <a
              href={`tel:${PHONE_TEL}`}
              className="inline-flex items-center justify-center gap-2.5 rounded-full bg-[#7c3aed] hover:bg-[#6d28d9] text-white font-semibold px-7 py-4 transition-all hover:-translate-y-0.5 cta-glow"
            >
              <Phone className="w-5 h-5" strokeWidth={2.5} />
              Call {PHONE}
            </a>
            <a
              href="#services"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-transparent border-2 border-[#1e183a] text-[#1e183a] font-semibold px-7 py-4 transition-all hover:bg-[#1e183a] hover:text-white group"
            >
              Explore Services
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
          </div>

          <div className="reveal mt-10 flex flex-wrap items-center gap-x-7 gap-y-3">
            {heroTags.map((t) => (
              <span
                key={t}
                className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-[#1e183a]"
              >
                <span className="w-2 h-2 rounded-full bg-[#7c3aed]" />
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Trustpilot rating strip */}
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pb-14">
        <div className="reveal flex flex-col sm:flex-row items-start sm:items-center gap-4 rounded-2xl bg-white/80 backdrop-blur border border-[#1e183a]/10 px-6 py-5 shadow-[0_10px_40px_-20px_rgba(19,26,51,0.4)] max-w-2xl">
          <div className="flex items-center gap-3">
            <span className="font-semibold text-[#1e183a]">Excellent</span>
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="grid place-items-center w-6 h-6 bg-[#00b67a]">
                  <Star className="w-4 h-4 text-white fill-white" />
                </span>
              ))}
            </div>
          </div>
          <div className="text-sm text-[#1e183a]/70">
            <span className="font-semibold text-[#1e183a]">4.9 out of 5</span> &middot; Based on
            1,247 reviews &middot; <span className="font-semibold text-[#00b67a]">Trustpilot</span>
          </div>
        </div>
        <p className="mt-2 text-xs text-[#1e183a]/50 max-w-2xl">
          Illustrative rating &mdash; this will show live reviews once a Trustpilot business profile is connected.
        </p>
      </div>

      {/* scroll hint */}
      <div className="hidden lg:flex flex-col items-center gap-2 absolute bottom-8 left-1/2 -translate-x-1/2 text-[#1e183a]/50">
        <Mouse className="w-5 h-5 animate-scroll-hint" />
        <span className="text-[11px] tracking-widest uppercase">Scroll</span>
      </div>
    </section>
  );
};

export default Hero;
